import { Badge } from "@/components/shadcn/badge";
import { getFormattedViewCounts } from "@/lib/utils";
import { cn } from "cn";
import { formatDistanceStrict } from "date-fns";
import { tr } from "date-fns/locale";
import { useTranslations } from "next-intl";

interface YoutubeVideoCardProps {
    video:
        | {
              id: string;
              snippet?: { title?: string; publishedAt?: string };
              statistics?: { viewCount?: number };
          }
        | null
        | undefined;
    className?: string;
    compact?: boolean;
}

export default function YoutubeVideoCard({
    video,
    className,
    compact = false,
}: YoutubeVideoCardProps) {
    const t = useTranslations("series");

    if (!video) return null;

    return (
        <div className={cn("flex flex-col gap-3", className)}>
            <div
                className={cn(
                    "relative aspect-video w-full overflow-hidden",
                    compact ? "rounded-lg" : "rounded-xl",
                )}
            >
                <iframe
                    className="absolute inset-0 h-full w-full"
                    src={`https://www.youtube.com/embed/${video.id}`}
                ></iframe>
            </div>
            <div className="flex flex-col gap-2">
                <h3
                    className={cn(
                        "font-semibold",
                        compact ? "line-clamp-2 text-sm" : "text-xl",
                    )}
                >
                    {video.snippet?.title}
                </h3>
                <div className="flex items-center gap-2">
                    <Badge
                        variant="secondary"
                        className="text-muted-foreground"
                    >
                        {getFormattedViewCounts(video.statistics?.viewCount)}{" "}
                        {t("views")}
                    </Badge>
                    {video.snippet?.publishedAt && (
                        <>
                            <span className="bg-border h-3 w-px" />
                            <span className="text-muted-foreground text-xs font-medium">
                                {formatDistanceStrict(
                                    new Date(video.snippet.publishedAt),
                                    new Date(),
                                    {
                                        addSuffix: true,
                                        locale: tr,
                                    },
                                )}
                            </span>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
